import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { Box, Tooltip, Typography } from "@mui/material";
import React from "react";
import { checkIf } from "../../utils";
import { setGeneralSettings } from "../../store/generalSettingsSlice";

export interface ICan {
  children: React.ReactElement;
  permission: string;
  render?: boolean;
  styleName?: any;
}

const Can = React.forwardRef((props: ICan, ref) => {
  const user = useSelector((state: RootState) => state.user);
  const dispatch = useDispatch();
  const trialCheck = user.partner;
  const { children, permission, render, ...other } = props;
  const clonedElement = React.cloneElement(children, {
    onClick: (e: any) => {
      e.preventDefault();
      e.stopPropagation();
      if (trialCheck?.inTrial) {
        dispatch(setGeneralSettings({ trialPopup: true }));
      }
    },
    trial: Boolean(trialCheck?.inTrial),
    readOnly: true,
    InputProps: { ...children.props.InputProps, readOnly: true },
  });
  if (checkIf(user.permissions) && Array.from(user.permissions as Set<string>).includes(permission)) {
    return children;
  } else {
    return render === false ? null : trialCheck?.inTrial ? (
      <Tooltip
        {...props}
        ref={ref}
        title={
          <Box className={props.styleName} sx={{ display: "flex", flexDirection: "column" }}>
            <Typography sx={{ fontSize: "11px", fontWeight: 600 }}>
              Trial users do not have access to this menu.
            </Typography>
            <Typography sx={{ fontSize: "11px", fontWeight: 600, textAlign: "center" }}>
              Upgrade for full access.
            </Typography>
          </Box>
        }
        placement="top"
        arrow
      >
        <Box sx={{ position: "relative", flex: 1 }}>
          {clonedElement}
          <Box
            sx={{
              position: "absolute",
              right: "4px",
              top: "4px",
              borderRadius: "25px",
              fontSize: "9px",
              fontWeight: 600,
              background: "linear-gradient(0deg, #ff9e0c 0%, #ffb309 100%)",
              padding: "0px 4px",
              color: "white",
            }}
          >
            FULL
          </Box>
        </Box>
      </Tooltip>
    ) : (
      <Tooltip {...props} ref={ref} title="You are not allowed to perform this action" placement="top" arrow>
        {clonedElement}
      </Tooltip>
    );
  }
});

export const ListWrapRenderer = (permissions: string[], userPermissions?: Set<string>) => {
  if (userPermissions !== undefined) {
    return permissions.some((perm) => Array.from(userPermissions).includes(perm));
  }
  return false;
};

export default Can;
